import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUpRightFromSquare, faClockRotateLeft, faLock } from "@fortawesome/free-solid-svg-icons";

import { EMPTY, formatDate } from "../../crmpostventa-shared/crmFormat";
import { altasBajasHref, isPlainClick } from "../../crmpostventa-shared/crmLinks";
import { formatCampoValor, isLocked, isTramite } from "../fichaFormat";
import { EstadoChip } from "./FichaHeader";

// Lock of a read-only or trámite field, with its help on hover or focus (design Prompt 1, point 3).
function LockTip({ ayuda }) {
  const text = ayuda || "Solo lectura";
  return (
    <span className="crm-ficha__tip" tabIndex={0} role="img" aria-label={text} data-tip={text}>
      <FontAwesomeIcon icon={faLock} aria-hidden="true" />
    </span>
  );
}

function FieldItem({ campo }) {
  const valor = formatCampoValor(campo);
  const locked = isLocked(campo);
  let content = valor;
  if (valor === EMPTY) content = <span className="crm-rollo__muted">{EMPTY}</span>;
  else if (campo.clave === "estado") content = <EstadoChip estado={valor} />;

  return (
    <div className={`crm-ficha__field${locked ? " is-locked" : ""}`}>
      <dt>
        {campo.etiqueta}
        {locked ? <LockTip ayuda={campo.ayuda} /> : null}
      </dt>
      <dd>{content}</dd>
    </div>
  );
}

/**
 * One of the four data cards (Identificación, Contacto, Fiscal, Bancario / operativo) with this terminal's own values:
 * empty values are "—", read-only fields carry a lock with their help, trámite fields go in "Se cambian con un trámite"
 * with "Ir a Altas/Bajas", and the footer shows the block's last change, which opens its history (onVerHistorial).
 */
export default function FichaCard({ seccion, clienteId, onVerHistorial, onNavigate }) {
  const campos = Array.isArray(seccion.campos) ? seccion.campos : [];
  const propios = campos.filter((campo) => !isTramite(campo));
  const tramite = campos.filter(isTramite);
  const ultimo = seccion.ultimoCambio;
  const titleId = `crm-ficha-sec-${seccion.clave}`;
  const altasHref = altasBajasHref({ clienteId });
  const ultimoText = ultimo ? `Último cambio: ${formatDate(ultimo.fecha)} · ${ultimo.usuario?.nombre || EMPTY}` : "";

  return (
    <section className="crm-ficha__card" aria-labelledby={titleId}>
      <h4 id={titleId}>{seccion.titulo}</h4>
      <dl className="crm-ficha__dl">
        {propios.map((campo) => (
          <FieldItem key={campo.clave} campo={campo} />
        ))}
      </dl>

      {tramite.length ? (
        <div className="crm-ficha__tramite">
          <div className="crm-ficha__tramite-head">
            <span>Se cambian con un trámite</span>
            <a
              className="crm-rollo__link crm-ficha__tramite-link"
              href={altasHref}
              onClick={(event) => {
                if (!onNavigate || !isPlainClick(event)) return;
                event.preventDefault();
                onNavigate(altasHref);
              }}
            >
              <FontAwesomeIcon icon={faArrowUpRightFromSquare} aria-hidden="true" />
              Ir a Altas/Bajas
            </a>
          </div>
          <dl className="crm-ficha__dl">
            {tramite.map((campo) => (
              <FieldItem key={campo.clave} campo={campo} />
            ))}
          </dl>
        </div>
      ) : null}

      <div className="crm-ficha__foot">
        {ultimo ? (
          <button
            type="button"
            className="crm-ficha__last"
            aria-label={`${ultimoText}. Ver el historial de ${seccion.titulo}`}
            onClick={() => onVerHistorial?.(seccion.clave)}
          >
            <FontAwesomeIcon icon={faClockRotateLeft} aria-hidden="true" />
            <span>{ultimoText}</span>
          </button>
        ) : (
          <span className="crm-ficha__last is-none">
            <FontAwesomeIcon icon={faClockRotateLeft} aria-hidden="true" />
            <span>Sin cambios registrados</span>
          </span>
        )}
      </div>
    </section>
  );
}
